import ContactIdMappingResourceModel from '../../generated/types/model/resource/ContactIdMappingResourceModel';

export default class ContactIdMappingResourceViewModel extends ContactIdMappingResourceModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
